import { Button } from 'components/buttons/Button/Button';

const ProductCard = ({ index, title, text, img, logo }) => {
    const number = String(index + 1).padStart(2, '0');

    return (
        <div className={`product-card ${index % 2 !== 0 ? 'product-card--reverse' : ''}`}>
            <div className="product-card__image" data-index={'• ' + number}>
                <svg width="125" height="64" viewBox="0 0 125 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M8 0C3.58172 0 0 3.58172 0 8V64C0 59.5817 3.58172 56 8 56H75.8831C78.4667 56 80.8912 54.7523 82.3929 52.6499L117.607 3.35009C119.109 1.24773 121.533 0 124.117 0H8Z"
                        fill="white"
                    />
                </svg>
                <img src={img} alt="product-item" className="product-card__image-bg" />
                {logo && (
                    <div className="product-card__image-logo">
                        <img src={logo} alt="product-logo" />
                    </div>
                )}
            </div>
            <div className="product-card__content">
                <h3>{title}</h3>
                <p className="body1">{text}</p>
                <Button type="learn-more-arrow">View product</Button>
            </div>
        </div>
    );
};

export default ProductCard;
